var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.853,
    height: 18.853,
    viewBox: "0 0 18.853 18.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0H18.853V18.853H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.569,15.569h-11v-11h5.5V3h-5.5A1.571,1.571,0,0,0,3,4.571v11A1.571,1.571,0,0,0,4.571,17.14h11a1.576,1.576,0,0,0,1.571-1.571v-5.5H15.569ZM11.641,3V4.571h2.82L6.739,12.293,7.847,13.4l7.722-7.722V8.5H17.14V3Z",
    transform: "translate(-0.643 -0.643)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.e4ea1a4d6d58e48fcad17cb6da9d6f32.svg";
export { ForwardRef as ReactComponent };